import React from "react";

import { FaUserCheck } from "react-icons/fa";

const Client = () => {
  const clients = [
    "Newgen Lanka Healthcare (P) Ltd, Srilanka",
    "Reliance Hospital, Kopar Khairane",
    "Zoetis Pharmaceutical Research Pvt. Ltd, Turbhe",
    "Ipca Laboratories, Ratlam",
    "Linde India Ltd, Taloja & Kolkata",
    "DCM Shriram Limited, Kota, Rajasthan",
    "Vinati Organics Ltd, Lote, Chiplun",
    "Crest Cellulose Pvt. Ltd, Naidupeta AP",
    "Jubilant Pharma & Chemical",
    "Advanced Enzymes, Thane",
    "Pollution Control Cell, TMC, Thane",
    "Kool-ex Cold Chain Limited, Mumbai",
    "Cipla, Patalganga",
    "Delta Finochem Pvt. Ltd, Nashik",
    "Jai Pharma, Sarigam, Vapi",
    "UPL, Ankleshwar",
    "Indofill, Dahej",
    "L&T, Mumbai",
    "Hanbi E&C India Pvt. Ltd",
    "CEAT Limited",
  ];

  return (
    <>
      <div
        className="h-[20rem] bg-cover bg-center relative flex items-center justify-start"
        style={{
          backgroundImage: 'url("./img/service/clients.webp")',
        }}
      >
        {/* Dark overlay to reduce image brightness */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        {/* Highlighted text */}
        <h1 className="absolute z-10 top-1/3 left-1/4 sm:top-1/4 sm:left-1/3 md:top-1/4 md:left-1/4 lg:top-40 lg:left-28 text-5xl font-extrabold text-white drop-shadow-xl">
          Client
        </h1>
      </div>

      <div className="bg-gray-100 py-10 px-5 md:px-10">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-teko font-bold text-center text-gray-800 mb-8">
            OUR VALUED CLIENTS
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
            {clients.map((client, index) => (
              <div
                key={index}
                className="flex items-start gap-3 bg-white p-4 rounded-lg shadow hover:shadow-lg transition-shadow duration-300"
              >
                <FaUserCheck className="text-blue-500 text-xl mt-1" />
                <p className="text-gray-700 text-lg font-medium">{client}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
export default Client;
